import { useMediaQuery, useTheme } from "@mui/material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import MobileTimesheetAccordion from "../components/MobileTimesheetAccordion";
import PageLayout from "../components/PageLayout";

interface Props {}

const RecentlyApproved: FunctionComponent<Props> = (
  props: Props
): JSX.Element => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PageLayout header={t("timesheets.title")}>
      {isSmallScreen && <MobileTimesheetAccordion type="recently approved" />}
    </PageLayout>
  );
};

export default RecentlyApproved;
